import { useEffect, useRef } from 'react';
import HeaderLink from "./comp/HeaderLink"
import { Link, useHistory } from 'react-router-dom';

import { callService } from '@Views/utils/ServiceUtils';
import logo from '@Images/header_logo.png';

const Header = ({ getMsg, routesJson, userInfo, setUserInfo }: any) => {

  const msg = getMsg();
  const routesMsg = getMsg('routes');
  const history = useHistory();

  const headerRef: any = useRef();

  const urlChange = async () => {
    await callService("OBMUE01U01");
  }

  const onMouseEnter = (e: any) => {
    if (headerRef['current']['classList'].contains("active") === false) {
      headerRef['current']['classList'].add('active');
    }
  }
  const onMouseLeave = (e: any) => {
    if (headerRef['current']['classList'].contains("active")) {
      headerRef['current']['classList'].remove('active');
    }
  }

  useEffect(() => {
    urlChange();
    return history.listen(() => {
      urlChange();
    })
  }, [history])

  return (
    <div className="wrap-head">
      <div className="header header-yh header_employment" ref={headerRef}>
        <div className="depth2Bg" onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}></div>
        <div className="header_innder clearfix" >
          <div className="gnb_leftFixTit" style={{ display: "flex" }}>
            <h1 className="logo_default">
              <Link className="logo_ecos" to='/Employment'>
                <span className="gnbTit">
                  <img src={logo} alt="한국은행" />
                </span>
              </Link>
            </h1>
            <span style={{ paddingTop: "15px", paddingLeft: "6px", fontSize: "17px", fontWeight: "500" }}>통계조사보조원 채용</span>
          </div>
          <div className="gnbMenu" onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave} onFocus={onMouseEnter}>
            <ul className="menu_list">
              <HeaderLink routesMsg={routesMsg} routesJson={routesJson} history={history} />
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Header;